/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ModelWithNodeActionsEntity,
  WorkflowModelEntity,
} from '../models/index';
import {
    ModelWithNodeActionsEntityFromJSON,
    ModelWithNodeActionsEntityToJSON,
    WorkflowModelEntityFromJSON,
    WorkflowModelEntityToJSON,
} from '../models/index';

export interface GetMyModelRequest {
    modelId: string;
    nodeActionType?: string;
}

export interface ListModelWithNodeActionsRequest {
    nodeActionType: string;
    filter?: string;
    skip?: string;
    take?: string;
}

export interface ListMyModelsRequest {
    nodeActionType?: string;
    filter?: string;
    skip?: string;
    take?: string;
}

/**
 * 
 */
export class MyModelApi extends runtime.BaseAPI {

    /**
     * 自分自身がアクション可能なモデルの一覧を取得する。
     */
    async getMyModelRaw(requestParameters: GetMyModelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkflowModelEntity>> {
        if (requestParameters['modelId'] == null) {
            throw new runtime.RequiredError(
                'modelId',
                'Required parameter "modelId" was null or undefined when calling getMyModel().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['nodeActionType'] != null) {
            queryParameters['nodeActionType'] = requestParameters['nodeActionType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/my/models/{modelId}`.replace(`{${"modelId"}}`, encodeURIComponent(String(requestParameters['modelId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkflowModelEntityFromJSON(jsonValue));
    }

    /**
     * 自分自身がアクション可能なモデルの一覧を取得する。
     */
    async getMyModel(requestParameters: GetMyModelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkflowModelEntity> {
        const response = await this.getMyModelRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 自分自身が権限を持つモデル一覧をアクション可能なノードとアクションとあわせて取得する。
     */
    async listModelWithNodeActionsRaw(requestParameters: ListModelWithNodeActionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ModelWithNodeActionsEntity>>> {
        if (requestParameters['nodeActionType'] == null) {
            throw new runtime.RequiredError(
                'nodeActionType',
                'Required parameter "nodeActionType" was null or undefined when calling listModelWithNodeActions().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['nodeActionType'] != null) {
            queryParameters['nodeActionType'] = requestParameters['nodeActionType'];
        }

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        if (requestParameters['skip'] != null) {
            queryParameters['skip'] = requestParameters['skip'];
        }

        if (requestParameters['take'] != null) {
            queryParameters['take'] = requestParameters['take'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/my/models/nodeActions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ModelWithNodeActionsEntityFromJSON));
    }

    /**
     * 自分自身が権限を持つモデル一覧をアクション可能なノードとアクションとあわせて取得する。
     */
    async listModelWithNodeActions(requestParameters: ListModelWithNodeActionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ModelWithNodeActionsEntity>> {
        const response = await this.listModelWithNodeActionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 自分自身がアクション可能なモデルの一覧を取得する。
     */
    async listMyModelsRaw(requestParameters: ListMyModelsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WorkflowModelEntity>>> {
        const queryParameters: any = {};

        if (requestParameters['nodeActionType'] != null) {
            queryParameters['nodeActionType'] = requestParameters['nodeActionType'];
        }

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        if (requestParameters['skip'] != null) {
            queryParameters['skip'] = requestParameters['skip'];
        }

        if (requestParameters['take'] != null) {
            queryParameters['take'] = requestParameters['take'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/my/models`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WorkflowModelEntityFromJSON));
    }

    /**
     * 自分自身がアクション可能なモデルの一覧を取得する。
     */
    async listMyModels(requestParameters: ListMyModelsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WorkflowModelEntity>> {
        const response = await this.listMyModelsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
